import { fmtNum } from "../../lib/format";
import {
  WEEKDAYS,
  buildMonthCells,
  type CalEvent,
  type CellSpec,
} from "./calendarData";

// 7-колоночная сетка месяца с шапкой дней недели. В ячейках с событиями
// показываем чипы в формате «+34 ₽ name», amort/погашение — акцентом.
export function CalendarGrid({
  year,
  month0,
  events,
  todayIso,
}: {
  year: number;
  month0: number;
  events: Map<string, CalEvent[]>;
  todayIso: string;
}) {
  const cells = buildMonthCells(year, month0);

  return (
    <>
      <div
        className="grid"
        style={{
          gridTemplateColumns: "repeat(7, 1fr)",
          gap: 6,
          marginBottom: 6,
        }}
      >
        {WEEKDAYS.map((d) => (
          <div
            key={d}
            className="label"
            style={{ textAlign: "center" }}
          >
            {d}
          </div>
        ))}
      </div>
      <div className="calgrid">
        {cells.map((c, i) => (
          <Cell
            key={i}
            cell={c}
            events={c.iso ? events.get(c.iso) ?? [] : []}
            isToday={c.iso === todayIso}
          />
        ))}
      </div>
    </>
  );
}

function Cell({
  cell,
  events,
  isToday,
}: {
  cell: CellSpec;
  events: CalEvent[];
  isToday: boolean;
}) {
  // Класс recv на ячейку — если хотя бы одно событие зачислено. Приоритет
  // фона решён в дизайне: recv > today > has. Today продолжает читаться
  // через стиль числа дня в CSS, поэтому конфликта нет.
  const anyReceived = events.some((e) => e.received === true);
  const cls = [
    "calcell",
    !cell.inMonth ? "empty" : "",
    events.length > 0 ? "has" : "",
    isToday ? "today" : "",
    anyReceived ? "recv" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls}>
      <div className="d">{cell.day ?? ""}</div>
      {events.slice(0, 4).map((e, i) => (
        <span
          key={i}
          className={[
            "cevt",
            e.type === "amort" ? "bigp" : "",
            e.projected ? "projected" : "",
            e.received === true ? "recv" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          title={`${e.name} · ${e.type === "amort" ? "погашение/амортизация" : "купон"}: +${fmtNum(e.amount)} ₽${e.received === true ? " · зачислено" : ""}${e.projected ? " (проекция: ставка ещё не объявлена)" : ""}`}
        >
          +{fmtNum(e.amount, 0)} ₽{" "}
          <span className="ename">{e.name}</span>
        </span>
      ))}
      {events.length > 4 && (
        <span className="soft" style={{ fontSize: 10, marginTop: 2, display: "block" }}>
          +{events.length - 4} ещё
        </span>
      )}
    </div>
  );
}
